var URL = './ASPWebDataServise.asmx/',
    fetchAsync = async (url, caption, body = null) => {
        let jb = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        if (body !== null) {
            let sendJSON = JSON.stringify(body);
            jb.body = "{inputsParam:'" + sendJSON + "'}";

        }
        const promise = await fetch(url + caption, jb);
        return await promise.json();
    };


$(document).ready(function () {

    $("body").fadeIn(2000);

    fetchAsync(URL, 'ListPerformersBySocialCertificates', {})
        .then(response => {
            let responseFormatting = response.d && JSON.parse(response.d),
                count = responseFormatting && responseFormatting.count;

            if (count && count >= 1)
                $('#reestr-social-certificates-block').show();
        },
            err => console.error(`ошибка при получении данных: ${err}`)
        );

});